import { getImageUrl } from "../utils/func";

function Image({ src, ...props }) {
  return <img {...props} crossOrigin="anonymous" src={getImageUrl(src)} />;
}

export default Image;
